export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.errorHandler = (error, _instance, _info) => {
    reloadOnFirebaseError(error);
    reloadOnIndexDBError(error);
    reloadOnModuleImportError(error);
  };
});

const reloadOnIndexDBError = (error: any) => {
  // https://arkad-nm.sentry.io/issues/4873605465/?project=4506294992764928&referrer=issue-stream&sort=os&statsPeriod=3d&stream_index=4
  if ("name" in error && error.name === "Error") {
    if (
      error.message.includes("UnknownError: Connection to Indexed Database server lost. Refresh the page to try again")
    ) {
      sentryWarnLog(`reloadOnIndexDBError: do reload: ${error}`);
      reloadNuxtApp();
    }
  }
};

const reloadOnModuleImportError = (error: any) => {
  // モジュール読み込みエラーのハンドリング
  if (error && typeof error === "object") {
    const errorMessage = error.message || error.toString();

    // モジュールスクリプト読み込み失敗のエラーパターンをチェック
    if (
      errorMessage.includes("Importing a module script failed") ||
      errorMessage.includes("Failed to fetch dynamically imported module") ||
      (errorMessage.includes("Loading chunk") && errorMessage.includes("failed")) ||
      (errorMessage.includes("Loading CSS chunk") && errorMessage.includes("failed")) ||
      errorMessage.includes("ChunkLoadError") ||
      (errorMessage.includes("Loading module") && errorMessage.includes("failed"))
    ) {
      sentryWarnLog(`reloadOnModuleImportError: do reload: ${error}`);
      // ページリロードでモジュールを再読み込み
      reloadNuxtApp();
    } else {
      // その他のモジュール関連エラーはログに記録
      sentryErrorLog(`reloadOnModuleImportError: skip reload: ${error}`);
    }
  }
};
